import { DEFAULT_TIMEZONE } from 'shared/mui/DatePicker/config/defaultValues';
import { formatInputInTz } from 'utils/date';

import { getPlaceholder } from './getPlaceholder';

type OptionsType = { format: string; timezone?: string };

export function formatInputToPlaceholder(
  value: unknown,
  { timezone = DEFAULT_TIMEZONE, format }: OptionsType,
): string {
  return formatInputInTz(value, { timezone, format, placeholder: getPlaceholder(format) });
}
